export class KeywordItem {
  keyword: string;
  rank: number;
  frequency: number;

  constructor() {
    this.keyword = '';
    this.rank = 0;
    this.frequency = 0;
  }
}

export class KeywordDataList {
  oneWordList: Array<KeywordItem>;
  twoWordList: Array<KeywordItem>;
  modalAnalysis: Array<ModalAnalysisData>;

  constructor() {
    this.oneWordList = [];
    this.twoWordList = [];
    this.modalAnalysis = [];
  }
}

export class ModalAnalysisData {
  id: number;
  regulatorRuleFullRequirement: string;

  constructor() {
    this.id = 0;
    this.regulatorRuleFullRequirement = '';
  }
}

